// src/utils/telefoneUtils.js
export const formatTelefone = (telefone = '') => {
    const telefoneNumerico = telefone.toString().replace(/\D/g, '');

    if (telefoneNumerico.length === 11) {
        return telefoneNumerico.replace(/(\d{2})(\d{5})(\d{4})/, '($1) $2-$3');
    }

    if (telefoneNumerico.length === 10) {
        return telefoneNumerico.replace(/(\d{2})(\d{4})(\d{4})/, '($1) $2-$3');
    }

    return telefone;
};
